import { useLanguage } from '../contexts/LanguageContext';

export const useMultilingual = () => {
  const { language, setLanguage, isRTL, getText, getLocalizedText } = useLanguage();

  const getLocalizedField = (obj: any, field: string): string => {
    return getLocalizedText(obj, field);
  };

  const getLocalizedName = (obj: any): string => {
    return getLocalizedField(obj, 'name');
  };

  const getLocalizedDescription = (obj: any): string => {
    return getLocalizedField(obj, 'description');
  };

  const getLocalizedBrand = (obj: any): string => {
    return getLocalizedField(obj, 'brand');
  };

  const getLocalizedCategoryName = (obj: any): string => {
    return getLocalizedField(obj, 'categoryName');
  };

  const getLocalizedCarMakeName = (obj: any): string => {
    return getLocalizedField(obj, 'carMakeName');
  };

  const getLocalizedCarModelName = (obj: any): string => {
    return getLocalizedField(obj, 'carModelName');
  };

  const formatPrice = (price: number): string => {
    if (language === 'ar') {
      return `${price.toLocaleString('ar-SA')} ر.س`;
    }
    return `$${price.toLocaleString('en-US')}`;
  };

  const formatDate = (dateString: string): string => {
    const date = new Date(dateString);
    if (language === 'ar') {
      return date.toLocaleDateString('ar-SA');
    }
    return date.toLocaleDateString('en-US');
  };

  const formatDateTime = (dateString: string): string => {
    const date = new Date(dateString);
    if (language === 'ar') {
      return date.toLocaleString('ar-SA');
    }
    return date.toLocaleString('en-US');
  };

  return {
    language,
    setLanguage,
    isRTL,
    getText,
    getLocalizedText,
    getLocalizedField,
    getLocalizedName,
    getLocalizedDescription,
    getLocalizedBrand,
    getLocalizedCategoryName,
    getLocalizedCarMakeName,
    getLocalizedCarModelName,
    formatPrice,
    formatDate,
    formatDateTime,
  };
};
